module.exports = __webpack_public_path__ + "assets/img/recordIcon4.bba53eab.png";